import React from 'react'

function Error() {
    return (
        <div>
            <h1>Something went wrong</h1>
        </div>
    )
}

export default Error
